import { CountryCode } from 'libphonenumber-js';
import { FormModel } from '../../../../components/Form';
import { Validators } from '../../../../utils/validators';

export const AddAgentsForm = (strings: any, defaultCountry: CountryCode, width = 4): FormModel[] => {
  return [
    {
      label: strings.agent_column_name,
      value: '',
      size: 'medium',
      autoFocus: true,
      type: 'text',
      typeValue: 'text',
      variant: 'outlined',
      placeholder: '',
      field: 'name',
      validators:
        width === 12 ? [] : [{ check: Validators.validateMandatoryField }, { check: Validators.validateString }],
      responsive: width === 12 ? { xs: 12 } : { xs: 12, sm: 4 },
      required: width !== 12,
    },
    {
      label: strings.agent_column_email,
      value: '',
      size: 'medium',
      autoFocus: false,
      type: 'text',
      typeValue: 'text',
      variant: 'outlined',
      placeholder: '',
      field: 'email',
      validators:
        width === 12
          ? []
          : [
            { check: Validators.validateEmail },
            { check: Validators.validateString },
          ],
      responsive: width === 12 ? { xs: 12 } : { xs: 12, sm: 4 },
      required: false,
    },
    {
      label: strings.agent_column_phone,
      value: {},
      size: 'medium',
      autoFocus: false,
      type: width === 12 ? 'text' : 'phoneInput',
      typeValue: 'number',
      variant: 'outlined',
      placeholder: '',
      field: 'phone',
      validators: width === 12 ? [] : [{ check: Validators.validateMobile }],
      responsive: width === 12 ? { xs: 12 } : { xs: 12, sm: 4 },
      required: false,
      defaultCountry: defaultCountry,
    },
  ];
};
